import request from '@/utils/request';

import { ResCode, PagingReq, User, CommonResponse } from './baseDefine';
export interface UserCommonReq extends PagingReq {
    user: User;
}
export interface UserList {
    code: ResCode;
    msg: string;
    data: UsersRes;
}
// 用户注册
export interface RegisterReq {
    userID: string;          // 用户ID
    email: string;           // 邮箱
    userName: string;        // 用户名
    emailCode: string;       // 邮箱验证码
    password: string;        // 密码
    confirmPassword: string; // 确认密码
    appUserType: number;
}
export interface UserReq extends PagingReq {
    appUserType: number;
    deleteState: number;
    userNO: string;             // 用户ID
    userName: number;           // 用户名
    email: string;              // 邮箱
    address: string;            // 地址
    serachCompanyID: number;
}
// 创建用户ID
export interface CreateUserIDReq {
    userNO: string;          // 用户ID
    userName: string;
    email: string;
    address: string;
    password: string;
    confirmPassword: string;
}
// 模糊搜索用户的请求结构
export interface QueryUserReq {
    queryUserType: number;
    query: string;
}
export interface UsersRes {
    users: UsersData;
}
export interface UsersData {
    list: User[];
    curPage: number;
    totalPage: number;
    totalCount: number;
    nextPage: number;
}
export interface CreateInstallUserReq {
    userType: number;         // 用户类型
    userName: string;
    userID: number;          // 管理员ID
    userIDString: string;    // 用户ID
    email: string;           // 邮箱
    password: string;        // 密码
    confirmPassword: string; // 确认密码
}
export interface UserBillList {
    code: ResCode;
    msg: string;
    data: UserBillsRes;
}
export interface UserBillsRes {
    userBills: UserBillsData;
}
export interface UserBillsData {
    list: UserBill[];
    curPage: number;
    totalPage: number;
    totalCount: number;
    nextPage: number;
}

export interface UserBill {
    id: number;
    userName: string;
    email: string;      // email
    bills: { [key: number]: Bill };
}
export interface Bill {
    meterType: string;   // 设备类型
    usage: number;  // 用量
    money: number;  // 账单金额
}
export function users(req: UserReq): Promise<UserList> {
    return request.post<UserList>('/api/user/users', req);
}

export function userBills(req: PagingReq): Promise<UserBillList> {
    return request.post<UserBillList>('/api/user/userBills', req);
}

export function updateUser(req: UserCommonReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/user/updateUser', req);
}
export function deleteUser(req: UserCommonReq): Promise<CommonResponse> {
    return request.post<UserList>('/api/user/deleteUser', req);
}
export function registerUser(req: RegisterReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/user/register', req);
}
export function createInstallUser(req: CreateInstallUserReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/admin/auth/createInstallUser', req);
}
export function queryUser(req: QueryUserReq): Promise<UserList> {
    return request.post<UserList>('/api/query/user', req);
}
export function doCreateUserID(req: CreateUserIDReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/user/createUserID', req);
}
